<template>
  <div id="overlay">
    <div class="center w-6/12">
      <div class="text-gray-800 text-2xl bg-white">
        {{ this.title }}
      </div>
      <div class="content bg-white p-2 flex flex-col">
        <div class="text-gray-800 text-xl my-3">
          {{ this.message }}
        </div>
      </div>
      <div class="w-full flex">
        <div class="flex flex-row w-full p-1">
          <button style="background-color:#51C546FF" class="mr-1 w-full h-12 label text-whiteText text-xs" @click.prevent="onConfirm(id)">
            Confirm
          </button>
          <button class="w-full h-12 bg-button label text-whiteText text-xs" @click.prevent="onDecline">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {

  },

  props: {
    title: String,
    message: String,
    onConfirm: Function,
    onDecline: Function,
    id: Number,
  },
};
</script>
<style scoped>
.center:hover {
  box-shadow: 1px 1px #000000, 2px 2px #000000, 3px 3px #04080a;
}

.center {
  transition: all 0.5s;
  background: #fff;
}

button {
  transition: all 0.3s;
}

button:hover {
  background-color: gray !important;
}
</style>
